import {
  ADD_PRODUCT_TO_CART_SUCCESS, REMOVE_PRODUCT_FROM_CART_SUCCESS, DELETE_CART_ROW_SUCCESS
} from "../actions/actionTypes";

export const analytics = () => next => action => {
  const { payload, type, cartRow } = action;
  window.dataLayer = window.dataLayer || [];
  switch (type) {
    case ADD_PRODUCT_TO_CART_SUCCESS:
      const productData = payload.getIn(['cart', 0, 'product']);
      window.dataLayer.push({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'SEK',
          add: {
            products: [
              {
                id: productData.get('id'),
                name: productData.get('name'),
                price: productData.get('price'),
                brand: productData.getIn(['brand', 'name']),
                category: productData.get('category'),
                quantity: 1,
              }
            ]
          }
        }
      });
      break;
  
    case REMOVE_PRODUCT_FROM_CART_SUCCESS:
    case DELETE_CART_ROW_SUCCESS:
      const product = cartRow.get('product');
      window.dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          remove: {
            products: [
              {
                name: product.get('name'),
                id: product.get('id'),
                price: product.get('price'),
                brand: product.getIn(['brand', 'name']),
                category: product.get('category'),
                quantity: type === DELETE_CART_ROW_SUCCESS ? cartRow.get('quantity') : 1
              }
            ]
          }
        }
      });
      break;
      
    default:
  }
  
  return next(action);
};



// WEBPACK FOOTER //
// ./src/store/analyticsMiddleware.js